let getCookie = function(name) {
  var arr;
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  if ((arr = document.cookie.match(reg)) && arr[2] !== '') {
    return unescape(arr[2]);
  } else {
    return null;
  }
};
export const setCookie = (key, value) => {
  if (!key) return;

  if (typeof key === 'object') {
    Object.keys(key).forEach((prop) => {
      setCookie(prop, key[prop]);
    });
    return;
  }
  let newCookie = key + '=' + value;
  document.cookie = newCookie;
};

if (process.env.NODE_ENV === 'development') {
  const cookies = {
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6IjE3NjAwOTAyNjE1IiwiaWF0IjoxNjEzMDIwMjUyLCJleHAiOjE2MTU2MTIyNTIuODQ5MDk3Mywic2NvcGVzIjpbInVzZXIiXSwiaW9yZGVyX3VzZXJfaWQiOm51bGwsInB3ZF91cGRhdGVfdGltZSI6IjIwMjEwMTI4MTQzNjI0IiwidWlkIjoxNDc0OH0.9BEDPBPxoCNi_jaEoaCwbw_wTk7foG92HZCnrmRTiPw',
    // orgcode: '031222111',
    // farmorg: '421001-0-0'
    orgcode: '161322001',
    farmorg: '434701-0-0'
  };
  setCookie(cookies);
}
export const FARM_ORG = getCookie('farmorg');
// 分公司id
export const ORG_CODE = getCookie('orgcode');
// 当前绑定农场为什么样的农场。true 表示非演示农场，false表示演示农场。
export const ISDEMO = getCookie('farm_flag') === 'false';
// 用于ios 判断是否强制去更新app
export const GPS = getCookie('location');
// 是否开启定位
export const LOCATION = getCookie('location') === 'opend';
// 交互唯一识别码
export const TOKEN = getCookie('token');
// // 是否有删除权限
export const DELETE = getCookie('level_delete') === 'true';

export const SETTLEMENTDATE = {
  timeStamp: 0,
  limitDate: new Date(0)
};
//处理安卓比ios版本不一样问题
export const TEMPVERSON = {
  android: false
};
//当前模块
export const CURRENTMODAL = {
  modal: ''
};
